export default {
    apiKey: "AIzaSyBqJwnIjCSOe5-TUQsRm_D46PbPBbT8se0",
    authDomain: "morphoglyph.firebaseapp.com",
    projectId: "morphoglyph",
    storageBucket: "morphoglyph.appspot.com",
    messagingSenderId: "772032469648",
    appId: "1:772032469648:web:5a52b836021546702f9615"
};
